import { reveal } from "@components/animations";
import { ForwardBtn } from "@components/shared";
import { homeAboutSectionData } from "@demo-data/about-me";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/system";
import { hexToRGBA } from "@utils/hex-to-rgba";
import { addScriptDefault } from "meta-pixel";
import { CSSProperties } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Link } from "react-router-dom";

export default function About() {
  const theme = useTheme();
  const { aboutData, overleafResume, image } = homeAboutSectionData || {};
  const fillStyle = {
    "--anim-fill-color": hexToRGBA(theme.palette.primary.main, 0.2),
  } as CSSProperties;

  return (
    <>
      <ForwardBtn title="About" isShowBackBtn={false} />
      <Grid container spacing={2} alignItems={"center"}>
        <Grid item xs={12} md={6}>
          <Stack spacing={3} py={{ xs: 2, sm: 3, md: 8 }}>
            {aboutData?.map((item, index) => (
              <Typography
                color="text.secondary"
                fontWeight={400}
                fontSize={{
                  xs: 14,
                  sm: 16,
                }}
                key={item.id}
                {...reveal("up", index * 80)}
              >
                {item.text}
              </Typography>
            ))}

            <Box
              {...reveal("up", (aboutData?.length ?? 0) * 80)}
              display="flex"
              flexDirection={{ md: "row", xs: "column" }}
              gap={2}
            >
              <Button
                variant="outlined"
                component={Link}
                to="/about"
                startIcon={<ReadMoreIcon />}
                color="primary"
                className="anim-fill"
                style={fillStyle}
              >
                Read more about me
              </Button>
              <Button
                variant="outlined"
                component={Link}
                target="_blank"
                rel="noopener noreferrer"
                to={overleafResume}
                startIcon={<PictureAsPdfIcon />}
                color="primary"
                className="anim-fill"
                style={fillStyle}
                onClick={() => {
                  const fbq = addScriptDefault();
                  fbq("trackCustom", "DownloadCV");
                }}
              >
                Download CV
              </Button>
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={12} md={6} {...reveal("right", 120)}>
          <Stack alignItems="flex-end">
            <Box
              sx={{
                width: {
                  xs: "100%",
                  sm: "auto",
                  md: 300,
                  lg: 400,
                },
                height: {
                  xs: "auto",
                  sm: "auto",
                  md: 400,
                  lg: 500,
                },
                //filter: isDark && 'grayscale(100%)',
                aspectRatio: "1/1",
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              <LazyLoadImage
                alt="about-image"
                effect="blur"
                src={image}
                width={"100%"}
                height={"100%"}
              />
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}
